import React from 'react';
import '../styles/ContactForm.css';
import {
  FaPhone,
  FaEnvelope,
  FaGlobe,
  FaMapMarkerAlt,
  FaFacebookF,
  FaLinkedinIn,
  FaYoutube
} from 'react-icons/fa';

import buildingImage from '../Assets/Images/akij-foundation-school-and-college.jpg';

function ContactForm() {
  return (
    <div className="contactf-container">
      <div className="contactf-wrapper">

        {/* Left: Contact Form */}
        <div className="contactf-content">
          <h2>Want to contact with us?</h2>
          <form className="contactf-form">
            <label htmlFor="name">Name: <span className="required">*</span></label>
            <input type="text" id="name" placeholder="Enter Your Name" required />

            <label htmlFor="email">Email: <span className="required">*</span></label>
            <input type="email" id="email" placeholder="Enter Your Email" required />

            <label htmlFor="subject">Subject: <span className="required">*</span></label>
            <input type="text" id="subject" placeholder="Enter Your Subject" required />

            <label htmlFor="message">Message: <span className="required">*</span></label>
            <textarea id="message" placeholder="Enter Your Message" required></textarea>

            <button type="submit">Submit</button>
          </form>
        </div>

        {/* Right: Address Card */}
        <div
          className="contact-left"
          style={{ backgroundImage: `url(${buildingImage})` }}
        >
          <div className="contact-card">
            <p>
              <FaMapMarkerAlt /> Monowara Complex, Binnadangi, Jamirta, Singair, Manikganj.
            </p>
            <p><FaPhone /> Cell: <span className="highlight">+880 1326-713076</span></p>
            <p><FaPhone /> Office: <span className="highlight">+880 9604317027</span></p>
            <p>
              <FaEnvelope /> Email: <a href="mailto: info@afvs.edu.bd"> info@afvs.edu.bd</a>
                                    <br />
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <a href="mailto: admission@afvs.edu.bd"> admission@afvs.edu.bd</a>
            </p>
            <p>
              <FaGlobe /> Web: <a href="https://www.afvs.edu.bd" target="_blank" rel="noopener noreferrer">afvs.edu.bd</a>
            </p>
            <div className="social-icons">
              <FaFacebookF />
              <FaLinkedinIn />
              <FaYoutube />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default ContactForm;
